import { Component, OnInit } from '@angular/core';
import { KuiModalRefComponent } from 'app/key-ui/modal/modal-ref.component';
import { TranslateService } from '@ngx-translate/core';
import { IKuiModalAction } from 'app/key-ui';

export interface ThemeCssModalOptions {
    css: any;
}

@Component({
    templateUrl: './css-modal.component.html',
    standalone: false
})
export class ThemeCssModalComponent extends KuiModalRefComponent<ThemeCssModalOptions> implements OnInit {

    modalActions: IKuiModalAction[];
    css: string;
    errorMessage: string;

    constructor(private i18n: TranslateService) {
        super();
    }

    ngOnInit() {

        this.css = this.data.css;

        this.modalActions = [{
            text: this.i18n.instant('DIALOG.CANCEL'),
            style: 'secondary',
            action: () => this.actions.close(),
        }, {
            text: this.i18n.instant('DIALOG.SAVE'),
            style: 'primary',
            action: async () => {

                try {
                    await this.actions.save(this.css);
                    this.closeModal();
                } catch (err) {
                    console.log(err);
                    this.errorMessage = err.message;
                    return true;
                }
            },
        }];

    }

}
